import React, { useEffect } from 'react'
import { Col, Container, Form, Row } from 'react-bootstrap'
import { Controller, useFormContext } from 'react-hook-form'
import { ZoomSettingsFormValues } from '../../../Integration/IntegrationManagement/IntegrationSpecificSettings/Zoom/models'
import { FormFeedback } from '../../../../components/Form/FormFeedback'
import { ExternalUserServiceIntegration } from '../../../../models/User'

export type ZoomSettingsProps = {
  integration?: ExternalUserServiceIntegration
}

export const ZoomSettings: React.FC<ZoomSettingsProps> = ({ integration }) => {
  const {
    setValue,
    control,
    formState: { errors },
    watch,
  } = useFormContext<ZoomSettingsFormValues>()

  const getInitialRemoveSessionWhenNoRecording = () => {
    if (integration && integration.configuration.type === 'recording') {
      return integration.configuration.removeSessionWhenNoRecording ?? true
    }
    return true
  }

  useEffect(() => {
    if (integration) {
      setValue('integrationType', integration.configuration.type)
      if (integration.configuration.type === 'recording') {
        setValue('removeSessionWhenNoRecording', getInitialRemoveSessionWhenNoRecording())
      }
      if (integration.configuration.type === 'bot') {
        setValue('autoJoin', integration.configuration.autoJoin)
      }
    }
  }, [integration])

  const watchedType = watch('integrationType')
  return (
    <Container className='d-flex flex-column gap-4 p-0'>
      <Row>
        <Col>
          <Controller
            name='integrationType'
            control={control}
            render={({ field, fieldState }) => (
              <>
                <Form.Group className='mb-3' controlId='integrationType'>
                  <Form.Label>Integration Type</Form.Label>
                  <div className='select-wrapper'>
                    <Form.Select {...field} aria-label='Select Zoom integration Type'>
                      <option value='bot'>Assistant</option>
                      <option value='recording'>Recording</option>
                    </Form.Select>
                  </div>
                </Form.Group>
                {fieldState.error && <FormFeedback>{fieldState.error.message}</FormFeedback>}
              </>
            )}
          />
        </Col>
      </Row>

      {watchedType === 'bot' && (
        <Row>
          <Col>
            <Controller
              name='autoJoin'
              control={control}
              render={({ field, fieldState }) => (
                <>
                  <Form.Group className='mb-3' controlId='botName'>
                    <Form.Check checked={field.value === true} onChange={field.onChange} type='checkbox' id='autoJoin' label={`Auto Join to Meeting`} />
                  </Form.Group>
                  {fieldState.error && <FormFeedback>{fieldState.error.message}</FormFeedback>}
                </>
              )}
            />
          </Col>
        </Row>
      )}

      {watchedType === 'recording' && (
        <Row>
          <Col>
            <Controller
              name='removeSessionWhenNoRecording'
              control={control}
              render={({ field, fieldState }) => (
                <>
                  <Form.Group className='mb-3' controlId='removeSessionWhenNoRecorsing'>
                    <Form.Label>Recording</Form.Label>
                    <Form.Check
                      checked={field.value === true}
                      onChange={field.onChange}
                      type='checkbox'
                      id='removeSessionWhenNoRecordingCheckbox'
                      label={`Remove Meetings Without Recording`}
                    />
                  </Form.Group>
                  {fieldState.error && <FormFeedback>{fieldState.error.message}</FormFeedback>}
                </>
              )}
            />
          </Col>
        </Row>
      )}
    </Container>
  )
}
